import React from "react";
import { connect } from "react-redux";
import ProviderBase from "components/layout/ProviderBase";
import Button from "components/common/Button";

function AccessDeniedPage(props) {
    const handleClick = () => {
        window.history.back();
    };

    return (
        <ProviderBase pageTitle="Access Denied">
            <div className="full-width margin-md">
                <Button onClick={handleClick}>
                    <i className="fas fa-reply" /> &nbsp; Go Back
                </Button>
            </div>
        </ProviderBase>
    );
}

export default connect(
    // (state) => {
    //     return {
    //         isLoggedIn: state.user.isLoggedIn,
    //         userProfile: state.user.userProfile,
    //     };
    // },
    // (dispatch) => ({
    //     loadCurrentUser: () => dispatch(UserActions.loadCurrentUser()),
    // }),
)(AccessDeniedPage);
